import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { Member } from "common/types";

async function fetchMembers(workspaceId: string): Promise<Member[]> {
  return (await get(`workspaces/${workspaceId}/members`)).members;
}

export default function useMembers() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { membersKeys } = getQueryKeys(workspaceId);

  const {
    data: members,
    isLoading: isLoadingMembers,
    isError: isMembersError,
    refetch: refetchMembers,
  } = useQuery({
    queryKey: membersKeys.list,
    queryFn: () => fetchMembers(workspaceId),
  });

  return {
    members,
    isLoadingMembers,
    isMembersError,
    refetchMembers,
  };
}
